
var $form = document.querySelector('.js-tos-form'),
    $formSubmit = document.querySelector('.js-form-subscribe-btn'),
    $resultContainer = document.querySelector('.js-tos-result-wrapper'),
    $textContainer = document.querySelector('.js-tos-result-container'),
    $copyContent = document.querySelector('.js-tos-copy'),
    $pageTitle = document.querySelector('.js-title'),
    $pageSubTitle = document.querySelector('.js-subtitle');


function handleScroll(to) {
    window.scrollTo({
        top: to ? to.getBoundingClientRect().top + document.documentElement.scrollTop - 30 : 0,
        behavior: 'smooth'
    });
}

document.addEventListener('onToolsSubscribe', function(){
    var data = new FormData($form);

    fetch(postURL, {
        method: 'POST',
        body: data
    })
        .then(r => r.json())
        .then(data => {
            handleSuccess(data);
        })
});

function handleSuccess (successData) {

    $textContainer.innerHTML = '<div>'+successData.content+'</div>';
    handleAnimation();

    amplitude_log_event('tools_' + landing + '_generated', {
        'is_client': successData.is_client ? true : false
    });
}

function handleAnimation() {
    $form.classList.add('slide-up-out');
    $pageSubTitle.classList.add('slide-up-out');

    handleScroll($resultContainer);

    setTimeout(function(){
        $form.classList.add('hide');
        $pageSubTitle.classList.add('hide');
        $resultContainer.classList.add('slide-up');
        $resultContainer.style.display = 'block';
    },300)
}

$copyContent.addEventListener('click', function(e){
    $textContainer.classList.remove('user-select-none');
    copyToClipboard($copyContent, document.querySelector('#tos-result-container > div'));
    $textContainer.classList.add('user-select-none');
});

function ready() {
    if (typeof Bouncer != 'undefined' && typeof toolsSubscribe != 'undefined') {
        $formSubmit.removeAttribute('disabled');
        toolSubscribeInternal('.js-tos-form');
    } else {
        setTimeout(ready, 500);
    }
}

ready()